@if (canStar) {
  <app-custom-button
    [icon]="'star'"
    [tooltip]="isStarred ? 'Remove from favorites' : 'Add to favorites'"
    [active]="isStarred"
    (buttonClick)="toggle()"
  ></app-custom-button>
}
